export const API_DEACTIVATE_REQUEST = 'API_DEACTIVATE_REQUEST';
export const API_DEACTIVATE_SUCCESS = 'API_DEACTIVATE_SUCCESS';
export const API_DEACTIVATE_FAILURE = 'API_DEACTIVATE_FAILURE';
export const RESET_DEACTIVATE = 'RESET_DEACTIVATE';

export const DeactivateRequest = () => ({
  type: API_DEACTIVATE_REQUEST,
});

export const DeactivateSuccess = payload => ({
  type: API_DEACTIVATE_SUCCESS,
  payload,
});

export const DeactivateFailure = payload => ({
  type: API_DEACTIVATE_FAILURE,
  payload,
});

export const resetDeactivate = () => ({
  type: RESET_DEACTIVATE,
});

const initialState = {
  isFetched: false,
  fetching: false,
  error: null,
  isDeactivated: false,
};

export function DeactivateReducer(state = initialState, action) {
  switch (action.type) {
    case RESET_DEACTIVATE:
      return {
        ...state,
        error: false,
        isDeactivated: false,
      };
    case API_DEACTIVATE_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case API_DEACTIVATE_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
        isDeactivated: true,
      };
    case API_DEACTIVATE_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.payload,
        isFetched: true,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/deactivate.js